import { Dialog } from "primereact/dialog";
import LoadingOverlay from "react-loading-overlay-ts";
import { Container } from "react-bootstrap";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { changeDateFormat } from "../../../utils";

const rdtOnly = [
  { field: "VersionNumber", header: "Version" },
  { field: "MarkupDate", header: "Date" },
  { field: "Assignee", header: "Owner" },
  { field: "Markup", header: "Markup" },
];

export default function RdtCicPopUp({ visible, onCancel, loader, rejectionReasonsList }) {
  const dynamicColumns = () => [
    rdtOnly.map((col, i) => (
      <Column key={i} field={col.field} header={col.header} body={renderMappingBody} />
    )),
  ];

  const renderMappingBody = (options, rowData) => {
    let { field } = rowData;

    return (
      <>
        {field === "VersionNumber" && <span>{options[field]}</span>}
        {field === "MarkupDate" && <span>{changeDateFormat(options[field])}</span>}
        {field === "Assignee" && <span>{options[field]}</span>}
        {field === "Markup" && (
          <span>
            {options.count}. {options[field]}
          </span>
        )}
      </>
    );
  };

  return (
    <Dialog
      header="Rejection Reason"
      visible={visible}
      onHide={onCancel}
      style={{ width: "50vw" }}
    >
      <LoadingOverlay active={loader} spinner text="">
        <Container>
          <DataTable
            stripedRows
            size={"small"}
            scrollable
            responsiveLayout="scroll"
            className="mt-3"
            tableStyle={{
              width: "max-content",
              minWidth: "100%",
            }}
            value={rejectionReasonsList}
            emptyMessage="Nothing to show"
          >
            {dynamicColumns()}
          </DataTable>
        </Container>
      </LoadingOverlay>
    </Dialog>
  );
}